class CustomScrollbar extends HTMLElement {
  connectedCallback() {
    // Custom Elements の自動アップグレードと手動の connectedCallback 呼び出しが
    // 重複した場合に二重初期化を防ぐ
    if (this._initialized) return;
    this._initialized = true;

    this.productList = this.querySelector(".product-list__inner--scroller");
    this.scrollbar = this.querySelector(".scrollbar");
    this.scrollbarInner = this.querySelector(".scrollbar .inner");
    this.arrows = this.querySelector(".product-list__prev-next");

    if (!(this.productList && this.scrollbar && this.scrollbarInner)) return;

    this.productList.addEventListener("scroll", this.updateScrollbar.bind(this));

    this._resizeHandler = () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this.updateScrollbar(), 150);
    };
    window.addEventListener("resize", this._resizeHandler);

    this.scrollbar.addEventListener("mousedown", this.onMouseDown.bind(this));

    // 画像のロード完了で scrollWidth が変動するため、内部寸法の変化を ResizeObserver で追従し再計算する
    // (これがないと、初回 updateScrollbar の時点で scrollWidth==clientWidth と誤判定 → display:none のまま固定され、
    //  ユーザーがスクロールイベントを発火させるまで再表示されない)
    if (typeof ResizeObserver !== "undefined") {
      this._resizeObserver = new ResizeObserver(() => this.updateScrollbar());
      this._resizeObserver.observe(this.productList);
      Array.from(this.productList.children).forEach((child) => this._resizeObserver.observe(child));
    }

    this.updateScrollbar();
  }

  disconnectedCallback() {
    if (this._resizeHandler) {
      window.removeEventListener("resize", this._resizeHandler);
    }
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }

  updateScrollbar() {
    if (this.productList.scrollWidth <= this.productList.clientWidth) {
      this.scrollbar.style.display = 'none';
      if (this.arrows) this.arrows.style.display = 'none';
      return;
    } else {
      this.scrollbar.style.display = '';
      if (this.arrows) this.arrows.style.display = '';
    }

    const scrollPercentage =
      this.productList.scrollLeft /
      (this.productList.scrollWidth - this.productList.clientWidth);
    const innerWidth =
      (this.productList.clientWidth / this.productList.scrollWidth) * 100;
    const maxTranslate =
      this.scrollbar.clientWidth - this.scrollbarInner.clientWidth;

    this.scrollbarInner.style.width = `${Math.min(innerWidth, 100)}%`;
    this.scrollbarInner.style.transform = `translateX(${
      scrollPercentage * maxTranslate
    }px)`;

    // ボタンのdisabled制御
    if (this.arrows) {
      const prevBtn = this.arrows.querySelector('.prev-next-button--prev');
      const nextBtn = this.arrows.querySelector('.prev-next-button--next');
      const atStart = this.productList.scrollLeft <= 0;
      const atEnd = this.productList.scrollLeft >= this.productList.scrollWidth - this.productList.clientWidth - 1;

      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd;
    }
  }

  onMouseDown(e) {
    e.preventDefault();
    const scrollbarWidth = this.scrollbar.clientWidth;
    const innerWidth = this.scrollbarInner.clientWidth;

    const onMouseMove = (e) => {
      const newX = e.clientX - this.scrollbar.getBoundingClientRect().left;
      const maxTranslate = scrollbarWidth - innerWidth;
      const translate = Math.max(
        0,
        Math.min(newX - innerWidth / 2, maxTranslate)
      );
      const scrollPercentage = translate / maxTranslate;

      this.productList.scrollLeft =
        scrollPercentage *
        (this.productList.scrollWidth - this.productList.clientWidth);
      this.scrollbarInner.style.transform = `translateX(${translate}px)`;
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  }
}

customElements.define("custom-scrollbar", CustomScrollbar);

// Custom Elements は customElements.define() の呼び出し時に既に DOM 上にある要素も
// 自動でアップグレードされ、connectedCallback() がブラウザによって呼ばれる。
// よって DOMContentLoaded での手動初期化は不要 (二重初期化で scroll/resize リスナーが重複する原因になる)。
//
// Shopify テーマエディタでセクションを再読み込みした場合も、DOM 挿入時に自動で connectedCallback() が呼ばれる。